<template>
<div id="app">
  <fullscreen ref="fullscreen" @change="fullscreenChange">
  <!-- <Nav/> -->
  <!--Container-->
  <div class="shadow-lg mx-auto bg-white mt-4 md:mt-4">
    <button class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4
     rounded inline-flex items-center float-right" @click="toggle">
      <!-- <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg> -->
      <span>Plein écran</span>
    </button>
    <div class="w-full flex flex-wrap">
        <div class="flex-grow w-4/6  flex-col">
            <div class="flex flex-col justify-center md:justify-start
            my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-4">
               <CalculationForm
               :essences="essences"
               :materials="materials"
               :other="other"
               v-on:CO2Calculated="showResults"
               />
            </div>
            <div class="flex flex-col justify-center md:justify-start
            my-auto pt-8 md:pt-0 px-8 md:px-24 lg:px-4">
                <ResultTableGroup
                :co2Emmisions="co2Emmisions"
                :biogenic="biogenic"
                :capturedCo2Emmisions="capturedCo2Emmisions"
                :netEmmissions="netEmmissions"
                :storedCo2="storedCo2"
                :carEmmisions="carEmmisions"
                :powerConsumption="powerConsumption"
                :comparisonDataset="comparisonDataset"
                :apexchartData="apexchartData"
                :apexchartOptions="apexchartOptions"
                :apexchartDataBis="apexchartDataBis"
                :apexchartOptionsBis="apexchartOptionsBis"
                />
            </div>
        </div>
        <!-- Image Section -->
        <div class="w-2/6 flex-col">
           <Sidebar/>
        </div>
    </div>
  </div>
    </fullscreen>
</div>
</template>

<script>
import CalculationForm from './form/CalculationForm.vue';
// import Nav from './blocks/Header.vue';
import Sidebar from './blocks/Sidebar.vue';
// import ResultTable from './blocks/resultTable.vue';
import ResultTableGroup from './blocks/ResultTableGroup.vue';

import data from './data/data';

export default {
  name: 'App',
  components: {
    CalculationForm, ResultTableGroup, Sidebar,
  },
  props: ['result'],
  data() {
    return {
      fullscreen: false,
      essences: data.essences,
      materials: data.materials,
      other: data.other,
      co2result: null,
      co2Emmisions: {
        project: '-',
        m2: '-',
      },
      biogenic: {
        project: '-',
        m2: '-',
      },
      capturedCo2Emmisions: {
        project: '-',
        m2: '-',
      },
      netEmmissions: {
        project: '-',
        m2: '-',
      },
      storedCo2: {
        project: '-',
        m2: '-',
      },
      carEmmisions: {
        project: '-',
        m2: '-',
      },
      powerConsumption: {
        project: '-',
        m2: '-',
      },
      comparisonDataset: {
        wood: '-',
        concrete: '-',
        clay: '-',
        pouredConcrete: '-',
        acier: '-',
        aluminium: '-',
      },
      comparisonDatasetValues: {
        wood: null,
        concrete: null,
        clay: null,
        pouredConcrete: null,
        acier: null,
        aluminium: null,
      },
      chartistData: null,
      chartistOptions: null,
      apexchartData: null,
      apexchartOptions: null,
      apexchartDataBis: null,
      apexchartOptionsBis: null,
    };
  },
  methods: {
    toggle() {
      this.$refs.fullscreen.toggle(); // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    showResults(event) {
      if (!event) {
        return;
      }
      this.co2result = event.target;
      this.co2Emmisions = event.co2Emmisions;
      this.biogenic = event.biogenic;
      this.capturedCo2Emmisions = event.capturedCo2Emmisions;
      this.netEmmissions = event.netEmmissions;
      this.storedCo2 = event.storedCo2;
      this.carEmmisions = event.carEmmisions;
      this.powerConsumption = event.powerConsumption;
      this.comparisonDataset = event.comparisonDataset;
      this.comparisonDatasetValues = event.comparisonDatasetValues;
      this.apexchartData = [{
        name: 'Emissions nettes de gaz à effet de serre',
        data: [this.comparisonDatasetValues.wood, this.comparisonDatasetValues.concrete,
          this.comparisonDatasetValues.clay, this.comparisonDatasetValues.pouredConcrete],
      }];
      this.apexchartOptions = {
        legend: {
          show: false,
        },
        theme: {
          palette: 'palette1',
        },
        chart: {
          id: 'vuechart-example',
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        xaxis: {
          categories: ['Bois', 'Béton en blocs (parpaing)', 'Brique de terre cuite', 'Béton banché'],
        },
        colors: ['#66DA26', '#F9C80E', '#FF9800', '#D7263D'],
        yaxis: {
          forceNiceScale: true,
        },
      };
      this.apexchartDataBis = [{
        name: 'Emissions nettes de gaz à effet de serre',
        data: [this.comparisonDatasetValues.wood,
          this.comparisonDatasetValues.acier, this.comparisonDatasetValues.aluminium],
      }];
      this.apexchartOptionsBis = {
        legend: {
          show: false,
        },
        theme: {
          palette: 'palette1',
        },
        chart: {
          id: 'vuechart-example',
        },
        plotOptions: {
          bar: {
            distributed: true,
          },
        },
        xaxis: {
          categories: ['Bois', 'Acier', 'Aluminium'],
        },
        colors: ['#66DA26', '#F9C80E', '#FF9800'],
      };
    },
  },
};
</script>

<style>

/* body {
  background: linear-gradient(to bottom, #555, #999);
  background-attachment: fixed;
} */
</style>


<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>
